import { useTranslation } from 'react-i18next';

import UI from '../UI';
import useLocale from '../useLocale';

interface PlatformFeeLineProps {
  fee: number;
}

const PlatformFeeLine = ({ fee }: PlatformFeeLineProps) => {
  const { t } = useTranslation('common');
  const { formatCurrency } = useLocale();

  return (
    <UI.GridContainer sc={{ gutter: 0.5 }}>
      <UI.Div>
        <UI.GridContainer sc={{ columns: '2fr 1fr', small: true }}>
          <UI.Div>
            {t('platform_fee')}
          </UI.Div>
          <UI.Div sc={{ textAlign: 'right' }}>
            {formatCurrency(fee)}
          </UI.Div>
        </UI.GridContainer>
      </UI.Div>
    </UI.GridContainer>
  );
};

export default PlatformFeeLine;
